import React from 'react'

import { nanoid } from 'nanoid'

import StylePanel from '../../layouts/toolpanel/StylePanel'
import ImageUploadPanel from '../../layouts/toolpanel/ImageUploadPanel'

// tools1 - 선택/이동
import { ReactComponent as PointerSmallIcon } from '../../../assets/icons/pointer-small.svg'
import { ReactComponent as PointerMediumIcon } from '../../../assets/icons/pointer-medium.svg'
import { ReactComponent as PointerLargeIcon } from '../../../assets/icons/pointer-large.svg'

import { ReactComponent as MoveSmallIcon } from '../../../assets/icons/move-small.svg'
import { ReactComponent as MoveMediumIcon } from '../../../assets/icons/move-medium.svg'
import { ReactComponent as MoveLargeIcon } from '../../../assets/icons/move-large.svg'

// tools2 - 펜/하이라이트/도형/지우개
import { ReactComponent as PenPressureSmallIcon } from '../../../assets/icons/pen-pressure-small.svg'
import { ReactComponent as PenPressureMediumIcon } from '../../../assets/icons/pen-pressure-medium.svg'
import { ReactComponent as PenPressureLargeIcon } from '../../../assets/icons/pen-pressure-large.svg'

import { ReactComponent as PenSmallIcon } from '../../../assets/icons/pen-small.svg'
import { ReactComponent as PenMediumIcon } from '../../../assets/icons/pen-medium.svg'
import { ReactComponent as PenLargeIcon } from '../../../assets/icons/pen-large.svg'

import { ReactComponent as PenHighlightSmallIcon } from '../../../assets/icons/pen-highlight-small.svg'
import { ReactComponent as PenHighlightMediumIcon } from '../../../assets/icons/pen-highlight-medium.svg'
import { ReactComponent as PenHighlightLargeIcon } from '../../../assets/icons/pen-highlight-large.svg'

import { ReactComponent as EraserSmallIcon } from '../../../assets/icons/eraser-small.svg'
import { ReactComponent as EraserMediumIcon } from '../../../assets/icons/eraser-medium.svg'
import { ReactComponent as EraserLargeIcon } from '../../../assets/icons/eraser-large.svg'

import { ReactComponent as ShapeSmallIcon } from '../../../assets/icons/shape-small.svg'
import { ReactComponent as ShapeMediumIcon } from '../../../assets/icons/shape-medium.svg'
import { ReactComponent as ShapeLargeIcon } from '../../../assets/icons/shape-large.svg'

// tools2 - 펜/하이라이트/도형/지우개
import { ReactComponent as ImageSmallIcon } from '../../../assets/icons/image-small.svg'
import { ReactComponent as ImageMediumIcon } from '../../../assets/icons/image-medium.svg'
import { ReactComponent as ImageLargeIcon } from '../../../assets/icons/image-large.svg'

// tools3 - 삭제/복사
import { ReactComponent as TrashSmallIcon } from '../../../assets/icons/trash-small.svg'
import { ReactComponent as TrashMediumIcon } from '../../../assets/icons/trash-medium.svg'
import { ReactComponent as TrashLargeIcon } from '../../../assets/icons/trash-large.svg'

import { ReactComponent as CopySmallIcon } from '../../../assets/icons/copy-small.svg'
import { ReactComponent as CopyMediumIcon } from '../../../assets/icons/copy-medium.svg'
import { ReactComponent as CopyLargeIcon } from '../../../assets/icons/copy-large.svg'

import { updateHistoryStackAfterErase } from '../../../utils/undoRedoUtils'

// 선택/이동 도구 목록
const tools1 = [
  {
    toolId: 'select',
    name: '선택 - V',
    smallIcon: () => <PointerSmallIcon />,
    mediumIcon: () => <PointerMediumIcon />,
    largeIcon: () => <PointerLargeIcon />,
  },
  {
    toolId: 'move',
    name: '이동 - M',
    smallIcon: () => <MoveSmallIcon />,
    mediumIcon: () => <MoveMediumIcon />,
    largeIcon: () => <MoveLargeIcon />,
  },
]

// 펜 계열 도구 목록
const tools2 = [
  {
    toolId: 'pen-pressure',
    name: '그리기(필압) - P',
    smallIcon: () => <PenPressureSmallIcon />,
    mediumIcon: () => <PenPressureMediumIcon />,
    largeIcon: () => <PenPressureLargeIcon />,
  },
  {
    toolId: 'pen',
    name: '그리기 - D',
    smallIcon: () => <PenSmallIcon />,
    mediumIcon: () => <PenMediumIcon />,
    largeIcon: () => <PenLargeIcon />,
  },
  {
    toolId: 'pen-highlight',
    name: '그리기(하이라이트) - H',
    smallIcon: () => <PenHighlightSmallIcon />,
    mediumIcon: () => <PenHighlightMediumIcon />,
    largeIcon: () => <PenHighlightLargeIcon />,
  },
  {
    toolId: 'eraser',
    name: '지우개 - E',
    smallIcon: () => <EraserSmallIcon />,
    mediumIcon: () => <EraserMediumIcon />,
    largeIcon: () => <EraserLargeIcon />,
  },
  {
    toolId: 'shape',
    name: '도형 - S',
    smallIcon: () => <ShapeSmallIcon />,
    mediumIcon: () => <ShapeMediumIcon />,
    largeIcon: () => <ShapeLargeIcon />,
  },
]

const ToolBar = React.memo(
  ({
    boardId,
    isStudent,
    isWritable,
    // [path]
    paths,
    setPaths,
    // [state]
    setIsPenMode,
    selectedTool,
    setSelectedTool,
    selectionRect,
    setSelectionRect,
    selectionRectPathKeys,
    setSelectionRectPathKeys,
    lockedCheckKey,
    historyStack,
    setHistoryStack,
    // <stylePanel>
    isStylePanelVisible,
    setIsStylePanelVisible,
    colorVal,
    setColorVal,
    thicknessVal,
    setThicknessVal,
    selectedShape,
    setSelectedShape,
    isShapeFilled,
    setIsShapeFilled,
    // <imageUpload>
    scope,
    translate,
    setLockedCheckKey,
    getBoundingClientSgCanvas,
    uploadImage,
    openImageModal,
    getImageDataAndInitializePaths,
    // 동시편집
    ydocRef,
    yPathsRef,
    triggerAddPath,
    triggerUpdatePath,
  }) => {
    // 선택된 path 복사
    const handleCopySelectedPath = () => {
      let newPaths = { ...paths }
      let newSelectionRect = {
        top: Infinity,
        left: Infinity,
        right: -Infinity,
        bottom: -Infinity,
      }
      let newSelectionRectPathKeys = []

      // 기존 paths 배열의 zIndex를 정렬하여 배열로 변환
      let pathsArray = Object.entries(newPaths)

      ydocRef.current.transact(() => {
        for (let copySelectedKey of selectionRectPathKeys) {
          let copiedKey = nanoid()
          let copiedPath = { ...newPaths[copySelectedKey] }

          // 복사된 path 위치 수정
          copiedPath.x += selectionRect.width
          triggerAddPath(copiedKey, copiedPath)

          // selectionRect 크기 업데이트
          newSelectionRect.top = Math.min(copiedPath.y + copiedPath.minY, newSelectionRect.top)
          newSelectionRect.left = Math.min(copiedPath.x + copiedPath.minX, newSelectionRect.left)
          newSelectionRect.right = Math.max(copiedPath.x + copiedPath.maxX, newSelectionRect.right)
          newSelectionRect.bottom = Math.max(
            copiedPath.y + copiedPath.maxY,
            newSelectionRect.bottom
          )
          // selectionRectPathKeys 업데이트
          newSelectionRectPathKeys.push(copiedKey)

          // 복사된 path를 sortedPaths의 적절한 위치에 삽입
          let indexToInsert = pathsArray.findIndex(([key]) => key === copySelectedKey)
          pathsArray.splice(indexToInsert + 1, 0, [copiedKey, copiedPath])
        }

        // zIndex 재정렬
        let newZIndex = 0
        pathsArray.forEach(([key, path]) => {
          const yPath = yPathsRef.current.get(key)
          if (yPath) {
            yPath.set('zIndex', newZIndex)
            newZIndex++
          }
        })
      })

      // state update
      setSelectionRectPathKeys([...newSelectionRectPathKeys])

      // [undo/redo] 히스토리 스택에 기록
      // copy에는 undo/redo 아직 작업하지 않았음. 구조 정리 끝나면 생각해보겠음. zIndex 때문에 골치 아프다.
    }

    // 선택된 path 삭제
    const handleTrashSelectedPath = () => {
      let eraseStack = {
        type: 'erase',
        pathKeys: selectionRectPathKeys,
        pathData: Object.fromEntries(selectionRectPathKeys.map((k) => [k, paths[k]])),
      }

      ydocRef.current.transact(() => {
        for (let trashSelectedKey of selectionRectPathKeys) {
          delete paths[trashSelectedKey]

          // [동시편집]
          yPathsRef.current.delete(trashSelectedKey)
        }

        // 지우기 완료 후 zIndex 값 업데이트
        let newZIndex = 0
        Object.entries(paths).forEach(([key, path]) => {
          const yPath = yPathsRef.current.get(key)
          if (yPath) {
            yPath.set('zIndex', newZIndex)
            newZIndex++
          }
        })
      })

      // state update
      setSelectionRect({ top: 0, left: 0, width: 0, height: 0 })
      setSelectionRectPathKeys([])

      // [undo/redo] 히스토리 스택에 기록
      updateHistoryStackAfterErase({ boardId, eraseStack, historyStack, setHistoryStack })
    }

    const onclickToolBar = (e) => {
      if (lockedCheckKey) setLockedCheckKey('')
      if (e.pointerType === 'touch') setIsPenMode(false)
    }

    const onclick = (toolId) => {
      if (toolId !== 'select') setSelectionRectPathKeys([])

      if (
        toolId !== 'pen-pressure' &&
        toolId !== 'pen' &&
        toolId !== 'pen-highlight' &&
        toolId !== 'shape'
      )
        setIsStylePanelVisible(false)
      else {
        selectedTool === toolId
          ? setIsStylePanelVisible((prev) => !prev)
          : setIsStylePanelVisible(true)
      }

      setSelectedTool(toolId)
    }

    const onImageChange = async (e) => {
      console.log(e.target.files)

      if (e.target.files && e.target.files[0]) {
        getImageDataAndInitializePaths(await uploadImage(e.target.files[0]))
      }

      e.target.value = ''
    }

    return (
      <div
        className={`sg-absolute sg-left-12 md:sg-left-12 xl:sg-left-16 sg-top-1/2 sg--translate-y-1/2 sg-select-none sg-z-[99999] ${
          isWritable ? 'sg-block' : 'sg-hidden'
        }`}
        onPointerDown={onclickToolBar}
      >
        <div className='sg-flex sg-px-4 sg-py-10 md:sg-px-6 md:sg-py-10 xl:sg-px-8 xl:sg-py-16 sg-flex-col sg-rounded-[6px] xl:sg-rounded-[10px] sg-bg-sk-white sg-border-[1px] sg-border-sk-border-default sg-shadow-emphasize'>
          {/* tools1 - select/move */}
          <div className='sg-flex sg-flex-col sg-items-center sg-justify-center sg-gap-6 sg-divide-y xl:sg-gap-12 sg-divide-sk-border-default'>
            <div className='sg-flex sg-flex-col sg-items-center sg-justify-center sg-gap-6 xl:sg-gap-8'>
              {tools1.map((tool) => {
                return (
                  <button
                    key={tool.toolId}
                    title={tool.name}
                    onClick={() => onclick(tool.toolId)}
                    className={`sg-w-24 sg-h-24 md:sg-w-30 md:sg-h-30 xl:sg-w-40 xl:sg-h-40 sg-cursor-pointer sg-rounded-[4px] xl:sg-rounded-[6px] sg-flex sg-items-center sg-justify-center ${
                      selectedTool === tool.toolId
                        ? 'sg-bg-sk-background-normal-secondary sg-text-sk-primary-normal'
                        : 'sg-bg-sk-background sg-hover:bg-sk-background-normal-alternative sg-text-sk-label-info'
                    }`}
                  >
                    <i className='sg-block md:sg-hidden'>{tool.smallIcon()}</i>
                    <i className='sg-hidden md:sg-block xl:sg-hidden'>{tool.mediumIcon()}</i>
                    <i className='sg-hidden xl:sg-block'>{tool.largeIcon()}</i>
                  </button>
                )
              })}
            </div>

            {/* tools2 - pen-pressure/pen/pen-highlight/eraser/shape */}
            <div className='sg-flex sg-flex-col sg-items-center sg-justify-center sg-gap-6 sg-pt-6 xl:sg-gap-8 xl:sg-pt-12'>
              {tools2.map((tool) => {
                return (
                  <div key={tool.toolId} className='sg-relative'>
                    <button
                      key={tool.toolId}
                      title={tool.name}
                      onClick={() => onclick(tool.toolId)}
                      className={`sg-w-24 sg-h-24 md:sg-w-30 md:sg-h-30 xl:sg-w-40 xl:sg-h-40 sg-cursor-pointer sg-rounded-[4px] xl:sg-rounded-[6px] sg-flex sg-items-center sg-justify-center ${
                        selectedTool === tool.toolId
                          ? 'sg-bg-sk-background-normal-secondary sg-text-sk-primary-normal'
                          : 'sg-bg-sk-background sg-hover:bg-sk-background-normal-alternative sg-text-sk-label-info'
                      }`}
                    >
                      <i className='sg-block md:sg-hidden'>{tool.smallIcon()}</i>
                      <i className='sg-hidden md:sg-block xl:sg-hidden'>{tool.mediumIcon()}</i>
                      <i className='sg-hidden xl:sg-block'>{tool.largeIcon()}</i>
                    </button>
                    <div
                      className={`sg-absolute ${
                        isStylePanelVisible && tool.toolId === selectedTool
                          ? 'sg-block'
                          : 'sg-hidden'
                      } ${
                        selectedTool === 'shape'
                          ? 'sg-top-[-67px] sg-right-[-8px] md:sg-top-[-96.5px] md:sg-right-[-10px] xl:sg-top-[-104px] xl:sg-right-[-12px]'
                          : 'sg-top-[-48.5px] sg-right-[-8px] md:sg-top-[-67px] md:sg-right-[-10px] xl:sg-top-[-69.5px] xl:sg-right-[-12px]'
                      }`}
                    >
                      <StylePanel
                        selectedTool={selectedTool}
                        colorVal={colorVal}
                        setColorVal={setColorVal}
                        thicknessVal={thicknessVal}
                        setThicknessVal={setThicknessVal}
                        selectedShape={selectedShape}
                        setSelectedShape={setSelectedShape}
                        isShapeFilled={isShapeFilled}
                        setIsShapeFilled={setIsShapeFilled}
                      />
                    </div>
                  </div>
                )
              })}
            </div>

            {/* image */}
            <div className='sg-relative sg-flex sg-flex-col sg-items-center sg-justify-center sg-pt-6 xl:sg-pt-12'>
              <label
                key='image'
                title='이미지'
                onClick={() => onclick('image')}
                className={`sg-w-24 sg-h-24 md:sg-w-30 md:sg-h-30 xl:sg-w-40 xl:sg-h-40 sg-cursor-pointer sg-rounded-[4px] xl:sg-rounded-[6px] sg-flex sg-items-center sg-justify-center ${
                  selectedTool === 'image'
                    ? 'sg-bg-sk-background-normal-secondary sg-text-sk-primary-normal'
                    : 'sg-bg-sk-background sg-hover:bg-sk-background-normal-alternative sg-text-sk-label-info'
                }`}
              >
                <input
                  type='file'
                  className='sg-hidden'
                  accept='.jpg, .jpeg, .png'
                  onChange={onImageChange}
                  disabled={!isStudent}
                />
                <i className='sg-block md:sg-hidden'>
                  <ImageSmallIcon />
                </i>
                <i className='sg-hidden md:sg-block xl:sg-hidden'>
                  <ImageMediumIcon />
                </i>
                <i className='sg-hidden xl:sg-block'>
                  <ImageLargeIcon />
                </i>
              </label>
              <div
                className={`sg-absolute sg-top-[6px] sg-right-[-12px] md:sg-right-[-16px] ${
                  selectedTool === 'image' && !isStudent ? 'sg-block' : 'sg-hidden'
                }`}
              >
                <ImageUploadPanel
                  uploadImage={uploadImage}
                  openImageModal={openImageModal}
                  getImageDataAndInitializePaths={getImageDataAndInitializePaths}
                />
              </div>
            </div>

            {/* tools3 */}
            <div className='sg-flex sg-flex-col sg-items-center sg-justify-center sg-gap-6 sg-pt-6 xl:sg-gap-8 xl:sg-pt-12'>
              <button
                key='trash'
                title='쓰레기통 - R'
                className={`sg-w-24 sg-h-24 md:sg-w-30 md:sg-h-30 xl:sg-w-40 xl:sg-h-40 sg-rounded-[4px] xl:sg-rounded-[6px] sg-flex sg-items-center sg-justify-center ${
                  selectionRectPathKeys.length !== 0
                    ? 'sg-bg-sk-background-normal-secondary sg-text-sk-primary-normal sg-cursor-pointer'
                    : 'sg-bg-sk-background sg-text-sk-label-disable sg-cursor-default'
                }`}
                disabled={selectionRectPathKeys.length === 0}
                onClick={handleTrashSelectedPath}
              >
                <i className='sg-block md:sg-hidden'>
                  <TrashSmallIcon />
                </i>
                <i className='sg-hidden md:sg-block xl:sg-hidden'>
                  <TrashMediumIcon />
                </i>
                <i className='sg-hidden xl:sg-block'>
                  <TrashLargeIcon />
                </i>
              </button>

              <button
                key='copy'
                title='복사 - C'
                className={`sg-w-24 sg-h-24 md:sg-w-30 md:sg-h-30 xl:sg-w-40 xl:sg-h-40 sg-rounded-[4px] xl:sg-rounded-[6px] sg-flex sg-items-center sg-justify-center ${
                  selectionRectPathKeys.length !== 0
                    ? 'sg-bg-sk-background-normal-secondary sg-text-sk-primary-normal sg-cursor-pointer'
                    : 'sg-bg-sk-background sg-text-sk-label-disable sg-cursor-default'
                }`}
                disabled={selectionRectPathKeys.length === 0}
                onClick={handleCopySelectedPath}
              >
                <i className='sg-block md:sg-hidden'>
                  <CopySmallIcon />
                </i>
                <i className='sg-hidden md:sg-block xl:sg-hidden'>
                  <CopyMediumIcon />
                </i>
                <i className='sg-hidden xl:sg-block'>
                  <CopyLargeIcon />
                </i>
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  },
  (prevProps, nextProps) => {
    return (
      prevProps.isWritable === nextProps.isWritable &&
      prevProps.isStudent === nextProps.isStudent &&
      prevProps.selectedTool === nextProps.selectedTool &&
      prevProps.selectionRectPathKeys === nextProps.selectionRectPathKeys &&
      prevProps.lockedCheckKey === nextProps.lockedCheckKey &&
      prevProps.isStylePanelVisible === nextProps.isStylePanelVisible &&
      prevProps.colorVal === nextProps.colorVal &&
      prevProps.thicknessVal === nextProps.thicknessVal &&
      prevProps.selectedShape === nextProps.selectedShape &&
      prevProps.isShapeFilled === nextProps.isShapeFilled
    )
  }
)

export default ToolBar
